module.exports = __webpack_public_path__ + "img/enterprise_setup_1.6cdec213.svg";